module.exports = __webpack_public_path__ + "img/avatar_ico12.76ca33b1.jpg";